export const adminRouteNames = {
  root: '/admin',
  quotes: 'quotes',
  payments: 'payments',
  users: 'users',
}
